import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { DateTime } from 'luxon';

const DividerContainer = styled(Box)`
  width: 100%;
  margin: 16px 0;
`;

const DividerLine = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid var(--colorBlueGray1000);
  margin: 0 10px;
`;

const DividerText = styled.p`
  margin: 0;
  white-space: nowrap;
  color: #aeb9c8;
  font-size: 1.1rem;
  font-weight: 600;
`;

interface Props {
  date: string; // ISO date string
}

/* Date separator for grouping future orders by date */
const DateSeparator: FC<Props> = ({ date }) => {
  const dateTime = DateTime.fromISO(date);
  const formattedDate = dateTime.toFormat('yyyy-MM-dd');

  return (
    <DividerContainer display="flex" alignItems="center" padding="medium">
      <DividerLine />
      <DividerText>{formattedDate}</DividerText>
      <DividerLine />
    </DividerContainer>
  );
};

export default DateSeparator;
